/** Small numeric helpers shared by the canvases and scroll scenes. */

export const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

/** Progress of `value` through [start, end], clamped to 0..1. */
export const span = (value: number, start: number, end: number) => clamp01((value - start) / (end - start));

export const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);
export const easeInOut = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
